import { render } from "./ContentListPackaging.vue?vue&type=template&id=9015dc68"
import script from "./ContentListPackaging.vue?vue&type=script&lang=js"
export * from "./ContentListPackaging.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__